import React from 'react';
import {Button, Tooltip} from 'antd';
import {Link} from 'react-router-dom';
import {CustomIcon} from '../../common/custom-icon';

export function ClientsActions({ isAdmin, onRemoveSelected, onCheckSelected, onMoveSelected, onExport, onToggleSms, onMoveUp, onSendSms, page, hasSelected }) {
  let moveDir, moveText2, addLink, moveTo, moveTo2;

  if(page === 'req') {
    moveDir = ['Переместить в наши клиенты', 'Переместить в архив', 'our', 'arc'];
    addLink = '/req-clients/add';
  } else if(page === 'our') {
    moveDir = ['Переместить в потенциальные клиенты', 'Переместить в архив', 'req', 'arc'];
    addLink = '/our-clients/add';
  } else if(page === 'arc') {
    moveDir = ['Переместить в наши клиенты', 'Переместить в потенциальные клиенты', 'our', 'req'];
    addLink = '/arc-clients/add';
  }

  return (
    <div className="actions">
      <Action icon={'plus'} label={'Добавить'} to={addLink} type={'primary'} />
      {isAdmin && (
        <Tooltip placement="bottom" title={'Отправить СМС'}>
          <Button onClick={onSendSms} disabled={!hasSelected} className="ant-btn-icon-only"><CustomIcon icon={'sms'}/></Button>
        </Tooltip>
      )}
      <Action icon={'sync'} label={'Обновить'} onClick={onCheckSelected} enabled={hasSelected} />
      {isAdmin && <Action icon={'swap-left'} label={moveDir[0]} onClick={() => onMoveSelected(moveDir[2])} enabled={hasSelected} />}
      {isAdmin && <Action icon={'swap-right'} label={moveDir[1]} onClick={() => onMoveSelected(moveDir[3])} enabled={hasSelected} />}
      <Action icon={'up'} label={'Переместить в начало'} onClick={onMoveUp} enabled={hasSelected} />
      {isAdmin && <Action icon={'import'} label={'Импортировать из excel'} to={`${page}-clients/import`} />}
      {isAdmin && <Action icon={'save'} label={'Экпортировать в excel'} onClick={onExport} enabled={hasSelected} />}
      {isAdmin && <Action icon={'message'} label={'Вкл/выкл смс'} onClick={onToggleSms} enabled={hasSelected} />}

      {isAdmin && <Action icon={'delete'} label={'Удалить'} type={'danger'} enabled={hasSelected} onClick={onRemoveSelected} />}
    </div>
  );
}


function Action({ icon, label, loading = false, onClick, to, type = '', enabled = true }) {
  const button = (
    <Tooltip placement="bottom" title={label}>
      <Button icon={icon} loading={loading} onClick={onClick} type={type} disabled={!enabled} />
    </Tooltip>
  );

  return to ?  <Link to={to}>{button}</Link> : button;
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/actions.js